import styled from '@emotion/styled'
import { storeGet } from 'Helpers/localStorage'
import { fromUTCtoZoneFormatted, STORE_KEY_LIST } from 'mailup-react-helpers'
import {
  Checkbox,
  Chip,
  DatePicker,
  DatePickerButton,
  Flex,
  FlexItem,
  FormElement,
  HelpIcon,
  InputNumber,
  Panel,
  Select,
  SPACING_16,
  SPACING_32,
  SPACING_8,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_EXTRALIGHT,
  TEXT_VARIANT_STANDARD,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'

import {
  ACTION_MOVE_COPY,
  exceptionsState,
  rssFeedsState,
  taskState
} from 'Pages/Task/recoil/state/task'

import { handleFrom } from 'Helpers/dates'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'
import { ACTIVITY_OPTIONS } from './const'

const StyledDatePickerButton = styled(DatePickerButton)`
  .react-datepicker,
  .react-datepicker-popper {
    z-index: 100;
  }
`

const addTimezone = (date) => {
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  return handleFrom(date, TimeZoneCode)
}

const PanelExcetpions = () => {
  const intl = useIntl()
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const task = useRecoilValue(taskState)
  const [
    {
      activiteFor,
      StartDate,
      EndDate,
      FrequencyBlackoutDate,
      NotInWeekends,
      UrlFrequency,
      Url,
      urlFrequencyEnabled,
      frequencyBlackoutHourEnabled,
      startBOTime,
      endBOTime
    },
    setExceptionsState
  ] = useRecoilState(exceptionsState)
  const rssFeeds = useRecoilValue(rssFeedsState)

  const handleChangeActiviteFor = (val) => {
    setExceptionsState((prev) => ({
      ...prev,
      activiteFor: val,
      isDirty: true,
      StartDate: prev.StartDate,
      EndDate: val === 'FromToDate' ? prev.EndDate : null
    }))
  }

  const handleStartChange = (val) => {
    if (val) {
      setExceptionsState((prev) => ({
        ...prev,
        StartDate: val,
        isDirty: true
      }))
    }
  }

  const handleEndChange = (val) => {
    setExceptionsState((prev) => ({
      ...prev,
      EndDate: val,
      isDirty: true
    }))
  }

  const handleBlackoutDates = (val) => {
    if (
      !FrequencyBlackoutDate.some(
        (e) =>
          !e.Recurring &&
          fromUTCtoZoneFormatted(e.Date, TimeZoneCode, 'YYYY-MM-DD') ===
            fromUTCtoZoneFormatted(val, TimeZoneCode, 'YYYY-MM-DD')
      )
    ) {
      setExceptionsState((prev) => ({
        ...prev,
        isDirty: true,
        FrequencyBlackoutDate: [
          ...prev.FrequencyBlackoutDate,
          {
            Date: addTimezone(val),
            Recurring: false
          }
        ]
      }))
    }
  }

  const handleRecurringBoDates = (value) => {
    if (
      !FrequencyBlackoutDate.some(
        (e) =>
          e.Recurring &&
          fromUTCtoZoneFormatted(e.Date, TimeZoneCode, 'MM-DD') ===
            fromUTCtoZoneFormatted(value, TimeZoneCode, 'MM-DD')
      )
    ) {
      setExceptionsState((prev) => ({
        ...prev,
        isDirty: true,
        FrequencyBlackoutDate: [
          ...FrequencyBlackoutDate,
          {
            Date: addTimezone(value),
            Recurring: true
          }
        ]
      }))
    }
  }

  const handleChipClick = (e) => {
    const filteredDates = FrequencyBlackoutDate.filter((i) => e !== i)

    setExceptionsState((prev) => ({
      ...prev,
      FrequencyBlackoutDate: filteredDates,
      isDirty: true
    }))
  }

  const onChangeNotInWeekends = () => {
    setExceptionsState((prev) => ({
      ...prev,
      NotInWeekends: !prev.NotInWeekends,
      isDirty: true
    }))
  }

  const onChangeUrlFrequencyEnabled = (val) => {
    setExceptionsState((prev) => ({
      ...prev,
      urlFrequencyEnabled: !prev.urlFrequencyEnabled,
      KindOfUrl: val.target.checked ? 'RSS' : '',
      isDirty: true
    }))
  }

  const handleChangeUrl = (val) => {
    setExceptionsState((prev) => ({
      ...prev,
      Url: val,
      isDirty: true
    }))
  }

  const onChangeUrlFrequency = (val) => {
    if (val) {
      setExceptionsState((prev) => ({
        ...prev,
        isDirty: true,
        UrlFrequency: val
      }))
    }
  }

  const onChangeFrequencyBlackoutHourEnabled = () => {
    setExceptionsState((prev) => ({
      ...prev,
      isDirty: true,
      frequencyBlackoutHourEnabled: !prev.frequencyBlackoutHourEnabled
    }))
  }

  const handleStartBOHour = (value) => {
    if (value >= 0) {
      setExceptionsState((prev) => ({
        ...prev,
        isDirty: true,
        startBOTime: {
          ...prev.startBOTime,
          hours: value
        }
      }))
    }
  }

  const handleStartBOMinute = (value) => {
    if (value >= 0) {
      setExceptionsState((prev) => ({
        ...prev,
        isDirty: true,
        startBOTime: {
          ...prev.startBOTime,
          minutes: value
        }
      }))
    }
  }

  const handleEndBOHour = (value) => {
    if (value >= 0) {
      setExceptionsState((prev) => ({
        ...prev,
        isDirty: true,
        endBOTime: {
          ...prev.endBOTime,
          hours: value
        }
      }))
    }
  }

  const handleEndBOMinute = (value) => {
    if (value >= 0) {
      setExceptionsState((prev) => ({
        ...prev,
        isDirty: true,
        endBOTime: {
          ...prev.endBOTime,
          minutes: value
        }
      }))
    }
  }

  return (
    <>
      <Panel>
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({ id: 'Load.Task.FrequencyExceptionTitle' })}
        </Title>
        <SpacingVertical variant={SPACING_32} />
        <>
          <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
            {intl.formatMessage({ id: 'Load.Task.FrequencyActivityTitle' })}
          </Text>

          <HelpIcon
            text={intl.formatMessage({
              id: 'Load.Task.FrequencyActivityTooltip'
            })}
          />
        </>
        <SpacingVertical variant={SPACING_8} />
        <>
          <Flex alignItems='flex-start' columnGap='8px'>
            <FlexItem minWidth='300px' margin='0 24px 0 0' height='36px'>
              <Select
                searchable={false}
                value={activiteFor}
                options={ACTIVITY_OPTIONS.map((e) => ({
                  value: e.value,
                  label: intl.formatMessage({ id: e.label })
                }))}
                onChange={handleChangeActiviteFor}
                data-mu-test='select-activiteFor'
              />
            </FlexItem>

            {activiteFor === 'FromToDate' && (
              <FlexItem margin='8px 0 0 0'>
                <Text>{intl.formatMessage({ id: 'Load.Task.ToDay' })}</Text>
              </FlexItem>
            )}
            <DatePicker
              value={StartDate}
              callback={handleStartChange}
              minDate={new Date()}
              maxDate={activiteFor === 'FromToDate' ? EndDate : null}
              invalid={!StartDate}
            />

            {activiteFor === 'FromToDate' && (
              <>
                <FlexItem margin='8px 0 0 0'>
                  <Text>{intl.formatMessage({ id: 'Load.Task.FromDay' })}</Text>
                </FlexItem>
                <FormElement
                  feedback={
                    !EndDate
                      ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                      : null
                  }
                >
                  <DatePicker
                    value={EndDate}
                    callback={handleEndChange}
                    minDate={StartDate}
                    invalid={!EndDate}
                  />
                </FormElement>
              </>
            )}
          </Flex>
        </>
        {task.Detail.Action !== ACTION_MOVE_COPY && (
          <>
            <SpacingVertical variant={SPACING_32} />
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({ id: 'Load.Task.FrequencyExcludeTitle' })}
            </Text>
            <SpacingVertical variant={SPACING_16} />
            <Flex alignItems='flex-start'>
              <FlexItem width='160px' flexShrink='0' margin='4px 0 0 0'>
                <Text>
                  {intl.formatMessage({
                    id: 'Load.Task.FrequencyExcludeSpecificDate'
                  })}
                </Text>
              </FlexItem>
              <StyledDatePickerButton
                onChange={handleBlackoutDates}
                minDate={new Date()}
              />

              <Flex margin='0 0 0 24px' flexWrap='wrap' gap='8px'>
                {FrequencyBlackoutDate.filter((e) => !e.Recurring).map(
                  (e, index) => (
                    <FlexItem key={index}>
                      <Chip
                        icon='times'
                        label={fromUTCtoZoneFormatted(
                          e.Date,
                          TimeZoneCode,
                          'YYYY-MM-DD'
                        )}
                        // label={dateF(e.Date, 'YYYY-MM-DD')}
                        value={e}
                        onClick={handleChipClick}
                      />
                    </FlexItem>
                  )
                )}
              </Flex>
            </Flex>
            <SpacingVertical variant={SPACING_16} />
            <Flex alignItems='flex-start'>
              <FlexItem width='160px' flexShrink='0' margin='4px 0 0 0'>
                <Text>
                  {intl.formatMessage({
                    id: 'Load.Task.FrequencyExcludeRecurrentDate'
                  })}
                </Text>
              </FlexItem>
              <StyledDatePickerButton onChange={handleRecurringBoDates} />
              <Flex margin='0 0 0 24px' flexWrap='wrap' gap='8px'>
                {FrequencyBlackoutDate.filter((e) => e.Recurring).map(
                  (e, index) => (
                    <FlexItem key={index}>
                      <Chip
                        icon='times'
                        label={fromUTCtoZoneFormatted(
                          e.Date,
                          TimeZoneCode,
                          'MM-DD'
                        )}
                        value={e}
                        onClick={handleChipClick}
                      />
                    </FlexItem>
                  )
                )}
              </Flex>
            </Flex>
            <SpacingVertical />
            <Checkbox
              checked={NotInWeekends}
              onChange={onChangeNotInWeekends}
              label={intl.formatMessage({
                id: 'Load.Task.FrequencyExcludeWeekend'
              })}
              data-mu-test='checkBox-NotInWeekends'
            />
            <SpacingVertical />
            <Flex alignItems='flex-start' columnGap='8px'>
              <FlexItem margin='8px 0 0 0'>
                <Checkbox
                  checked={urlFrequencyEnabled && rssFeeds.items.length > 0}
                  onChange={onChangeUrlFrequencyEnabled}
                  label={intl.formatMessage({
                    id: 'Load.Task.FrequencyExcludeFeedFromDateLabelFirst'
                  })}
                  data-mu-test='checkBox-UrlFrequency'
                  disabled={rssFeeds.items.length === 0}
                />
              </FlexItem>
              <FormElement
                feedback={
                  urlFrequencyEnabled && !Url
                    ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                    : null
                }
              >
                <Flex display='block' minWidth='220px'>
                  <Select
                    searchable
                    value={Url}
                    options={rssFeeds.items}
                    onChange={handleChangeUrl}
                    data-mu-test='select-rssFeeds'
                    placeholder={intl.formatMessage({
                      id: 'Load.Task.FrequencyExcludeFeedSelectPlaceholder'
                    })}
                    disabled={
                      !urlFrequencyEnabled || rssFeeds.items.length === 0
                    }
                    error={urlFrequencyEnabled && !Url ? 'danger' : null}
                  />
                </Flex>
              </FormElement>
              <FlexItem margin='8px 0 0 0'>
                <Text
                  variant={
                    rssFeeds.items.length === 0
                      ? TEXT_VARIANT_EXTRALIGHT
                      : TEXT_VARIANT_STANDARD
                  }
                >
                  {intl.formatMessage({
                    id: 'Load.Task.FrequencyExcludeFeedFromDateLabelSecond'
                  })}
                </Text>
              </FlexItem>
              <FormElement
                feedback={
                  urlFrequencyEnabled && !UrlFrequency
                    ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                    : null
                }
              >
                <Flex display='block' width='70px'>
                  <InputNumber
                    min={0}
                    onChange={onChangeUrlFrequency}
                    value={UrlFrequency}
                    disabled={
                      !urlFrequencyEnabled || rssFeeds.items.length === 0
                    }
                    variant={
                      urlFrequencyEnabled && !UrlFrequency ? 'danger' : null
                    }
                  />
                </Flex>
              </FormElement>
              <FlexItem margin='8px 0 0 0'>
                <Text
                  variant={
                    rssFeeds.items.length === 0 ? 'extralight' : 'standard'
                  }
                >
                  {intl.formatMessage({
                    id: 'Load.Task.FrequencyExcludeFeedFromDateLabelThird'
                  })}
                </Text>
              </FlexItem>
            </Flex>
            <SpacingVertical />
            <Flex alignItems='flex-start' columnGap='8px'>
              <FlexItem margin='8px 0 0 0'>
                <Checkbox
                  checked={frequencyBlackoutHourEnabled}
                  onChange={onChangeFrequencyBlackoutHourEnabled}
                  label={intl.formatMessage({
                    id: 'Load.Task.FrequencyExcludeTimeFrom'
                  })}
                  data-mu-test='checkBox-frequencyBlackoutHourEnabled'
                />
              </FlexItem>
              <Flex display='block' width='70px'>
                <InputNumber
                  value={String(startBOTime.hours)}
                  onChange={handleStartBOHour}
                  disabled={!frequencyBlackoutHourEnabled}
                  min={0}
                  max={24}
                  precision={0}
                />
              </Flex>
              <FlexItem margin='8px 0 0 0'>
                <Text>:</Text>
              </FlexItem>
              <Flex display='block' width='70px'>
                <InputNumber
                  value={startBOTime.minutes}
                  onChange={handleStartBOMinute}
                  disabled={!frequencyBlackoutHourEnabled}
                  min={0}
                  max={59}
                  step={5}
                  precision={0}
                />
              </Flex>
              <FlexItem margin='8px 0 0 0'>
                <Text>
                  {intl.formatMessage({
                    id: 'Load.Task.FrequencyExcludeTimeTo'
                  })}
                </Text>
              </FlexItem>
              <Flex display='block' width='70px'>
                <InputNumber
                  value={String(endBOTime.hours)}
                  onChange={handleEndBOHour}
                  disabled={!frequencyBlackoutHourEnabled}
                  min={0}
                  max={24}
                  precision={0}
                />
              </Flex>
              <FlexItem margin='8px 0 0 0'>
                <Text>:</Text>
              </FlexItem>
              <Flex display='block' width='70px'>
                <InputNumber
                  value={endBOTime.minutes}
                  onChange={handleEndBOMinute}
                  disabled={!frequencyBlackoutHourEnabled}
                  min={0}
                  max={59}
                  step={5}
                  precision={0}
                />
              </Flex>
            </Flex>
          </>
        )}
      </Panel>
    </>
  )
}

export default PanelExcetpions
